export const formatTimezone = (timezone: string): string => {
  const renderTokens = (tokens: string[]): string =>
    tokens.length > 1 ? `${tokens[1]}` : tokens[0];

  const formattedTimezone = timezone.replace(/_/g, " ");
  const formattedTimezoneParts = formattedTimezone.split("/");
  formattedTimezoneParts.shift();

  return renderTokens(formattedTimezoneParts);
};
